import { render, staticRenderFns } from "./Rides.vue?vue&type=template&id=84f80fba&lang=pug"
import script from "./Rides.vue?vue&type=script&lang=js"
export * from "./Rides.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports